// ----------------- [ A4D Settings :: MUTATIONS ] ----------------- //

import {SET_PROPERTY_OBJECT, UPDATE_PROPERTY} from "../../basics/a4d_reusable_mutations";

export const mutations = {
    'SET_PROPERTY_OBJECT' : SET_PROPERTY_OBJECT,
    'UPDATE_PROPERTY' : UPDATE_PROPERTY,
};
